import { useState, useEffect } from 'react';
import publicClient from '../../api/publicClient';

export function isMaintenanceModeConfigured(): boolean {
  return import.meta.env.VITE_MAINTENANCE_MODE === 'true';
}

let healthCheckPromise: Promise<boolean> | null = null;

export function resetMaintenanceModeCache(): void {
  healthCheckPromise = null;
}

export function fetchMaintenanceStatus(): Promise<boolean> {
  if (isMaintenanceModeConfigured()) {
    return Promise.resolve(true);
  }
  if (!healthCheckPromise) {
    healthCheckPromise = publicClient
      .get<{ maintenance_mode?: boolean }>('/health')
      .then((response) => response.data?.maintenance_mode === true)
      .catch(() => false);
  }
  return healthCheckPromise;
}

export function useMaintenanceMode(): { isMaintenanceMode: boolean; isLoading: boolean } {
  const isPreConfigured = isMaintenanceModeConfigured();
  const [isMaintenanceMode, setIsMaintenanceMode] = useState<boolean>(isPreConfigured);
  const [isLoading, setIsLoading] = useState<boolean>(!isPreConfigured);

  useEffect(() => {
    if (isPreConfigured) {
      setIsMaintenanceMode(true);
      setIsLoading(false);
      return;
    }

    let cancelled = false;

    fetchMaintenanceStatus()
      .then((inMaintenance) => {
        if (!cancelled) {
          setIsMaintenanceMode(inMaintenance);
          setIsLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setIsLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [isPreConfigured]);

  return { isMaintenanceMode, isLoading };
}
